// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4dee02f5","747":"14759940","934":"a2be09fe"}[chunkId] + ".chunk.js";
};